<script lang="ts" setup>
  import { BaseInput } from '@qic/ui-components'
  import { computed } from 'vue'
  import { ID_MASK, ID_LENGTH, ID_TOKEN, ID_PATTERN } from './EmiratesIdInput.constants'

  interface Props {
    modelValue: string
    errors?: string[]
    dataTest?: string
  }

  interface Emits {
    (e: 'update:modelValue', value: string): void
    (e: 'completed', value: string): void
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
    dataTest: 'emirates-id-input',
  })

  const emit = defineEmits<Emits>()

  const value = computed({
    get: () => props.modelValue,
    set: (value) => {
      emit('update:modelValue', value)

      if (value.length === ID_LENGTH) {
        emit('completed', value)
      }
    },
  })
</script>

<template>
  <BaseInput
    v-model="value"
    v-bind="$attrs"
    input-mode="numeric"
    :label="$t('outbound.travelers.qatar_id')"
    :mask="ID_MASK"
    :max-length="ID_LENGTH"
    :mask-tokens="{ [ID_TOKEN]: { pattern: ID_PATTERN } }"
    :errors="errors"
    :data-test="dataTest"
  />
</template>
